import { useAuth0 } from '@auth0/auth0-react';
import { Collapse, Table, TableBody, TableCell, TableHead } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import { Box, IconButton } from '@mui/material';
import AuthService from "Lib/API/Auth";
import PreSchoolService from 'Lib/API/PreSchool';
import Action from 'components/ActionPopOver';
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from 'components/Dialog';
import Loader from 'components/loader/Loader';
import { formatDate } from 'helper/dateFormat';
import { numberFormat } from 'helper/numberFormat';
import { getCurrentRegisteredDate } from 'pages/NewEvents/Events/multiDateChanges';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useHistory } from "react-router-dom";
import thousands from 'thousands';
import { Account, AccountWrapper, Status } from './Theme';
import './index.scss';
import { fontConfig } from "theme/fontConfig";

const ParticipantDetailsTableBody = ({
  setOpenDrawer,
  setDrawerData,
  rows,
  loading,
  classId,
  refresh,
  setRefresh,
  onSharePaymentLinkClick,
  onCheckboxChange,
  check,
  checkAll,
  isMultiEvent,
  eventDates,
  isFreeEvent,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [paymentLinkId, setPaymentLinkId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [moveParticipantId, setMoveParticipantId] = useState(null);
  const [classMovedId, setClassMovedId] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [attendeeDialog, setAttendeeDialog] = useState(false);
  const [attendeeRow, setAttendeeRow] = useState(null);
  const [attendeeValue, setAttendeeValue] = useState(null);
  const [attendeeDateName, setAttendeeDateName] = useState('');
  const [attendeeLoading, setAttendeeLoading] = useState(false);
  const [attendedMap, setAttendedMap] = useState({});
  const [dateAttendanceMap, setDateAttendanceMap] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const eventName = useSelector((state) => state.events.eventName);
  const history = useHistory();

  const { getAccessTokenSilently } = useAuth0();

  const getStatusMessage = (newStatus, currentRow) => {
    if (currentRow?.registrationStatus === 'pending' && newStatus === 'approved') {
      return `You are about to admit ${currentRow?.firstName} ${currentRow?.lastName} into  Event ${eventName}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'pending' && newStatus === 'not-approve') {
      return `You are about to deny ${currentRow?.firstName} ${currentRow?.lastName} into  Event ${eventName}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'pending' && newStatus === 'on-hold') {
      return '';
    }
    if (currentRow?.registrationStatus === 'approved' && newStatus === 'not-approve') {
      return `You are about to deny ${currentRow?.firstName} ${currentRow?.lastName} from Event ${eventName}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'not-approve' && newStatus === 'approved') {
      return `You are about to admit ${currentRow?.firstName} ${currentRow?.lastName} into Event ${eventName}, please confirm`;
    }
    return ""
  };

  const getDeleteMessage = (currentRow) => {
    if (currentRow?.registrationStatus === 'pending') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Event ${eventName}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'approved') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Event ${eventName}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'not-approve') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Event ${eventName}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'on-hold') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Event ${eventName}, please confirm`;
    }
    return '';
  }
  const deleteEventParticipant = async (id) => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.deleteEventParticipantById(token, id);
      toastr.success(
        'Success',
        result?.result?.message || 'Participant deleted successfully'
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setDeleteId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };
  const changeStatus = async (status) => {
    const payload = {
      classId,
      participantId: status?.id,
      status: status?.value,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.changeStatusParticipant(
        token,
        payload
      );
      toastr.success(
        'Success',
        result?.result?.message || 'Participant status updated successfully'
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setSelectedStatus(null);
      setConfirmDialog(false);
      setCurrentRow(null);
      setConfirmLoading(false);
    }
  };

  const sendPaymentLink = async (id) => {
    const payload = {
      participantId: id,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.sendPaymentLink(token, payload);
      toastr.success(
        'Success',
        result?.result?.message || 'Payment link sent successfully'
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setPaymentLinkId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };

  const moveParticipantToAnotherClass = async () => {
    const payload = {
      newClass: classMovedId,
      participantId: moveParticipantId,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.moveParticipant(token, payload);
      toastr.success(
        'Success',
        result?.result?.message || 'Participant moved successfully'
      );
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setMoveParticipantId(null);
      setClassMovedId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setRefresh(!refresh);
    }
  };

 

  // Marking someone as attended saves right away; only un-marking asks for confirmation
  const handleAttendeeChange = (row, value, dateName = '') => {
    if (attendeeLoading) return;
    if (value) {
      saveAttendee(row, value, dateName);
      return;
    }
    setAttendeeRow(row);
    setAttendeeValue(value);
    setAttendeeDateName(dateName);
    setAttendeeDialog(true);
  };

  const confirmAttendee = () => saveAttendee(attendeeRow, attendeeValue, attendeeDateName);

  const saveAttendee = async (row, value, dateName = '') => {
    try {
      setAttendeeLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.markAttendee(token, {
        eventId: classId,
        participantId: row._id,
        name: dateName,
        attendee: value,
      });
      if (dateName) {
        const key = `${row._id}__${dateName}`;
        setDateAttendanceMap((prev) => ({ ...prev, [key]: value }));
      } else {
        setAttendedMap((prev) => ({ ...prev, [row._id]: value }));
      }
      toastr.success('Success', `Participant marked as ${value ? 'attended' : 'unattended'}`);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setAttendeeLoading(false);
      setAttendeeDialog(false);
      setAttendeeRow(null);
      setAttendeeValue(null);
      setAttendeeDateName('');
    }
  };


  const handleOnClickAccountId = (accountId, contactId) => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      AuthService.getContactById(contactId, token)
        .then((res) => {
          if (res) {
            history.push(`/member-details/${accountId}/family-member`, res[0])
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }

  return (
    <>
      {loading ? (
        <TableRow>
          <TableCell colSpan={8} align="center">
            <div className="user__loader" style={{ height: '320px' }}>
              <Loader />
            </div>
          </TableCell>
        </TableRow>
      ) : rows?.length === 0 ? (
        <TableRow>
          <TableCell colSpan={8} align="center">
            <h6>No Participants Found</h6>
          </TableCell>
        </TableRow>
      ) : (
        rows?.map((row) => (
          <React.Fragment key={row._id}>
          <TableRow>
              <TableCell
                align="left"
              >
               <CheckBox
                  onChange={(e) => onCheckboxChange(e, row)}
                  checked={checkAll ? true : check.find((obj) => obj._id === row?._id)}
                  text={""}
                  isDisabled={checkAll}
                />
             </TableCell>
            {isMultiEvent && (
              <TableCell align="left" style={{ padding: '0 4px' }}>
                <IconButton
                  aria-label="expand row"
                  size="large"
                  onClick={() =>
                    setExpandedRows((prev) => ({ ...prev, [row._id]: !prev[row._id] }))
                  }
                  className="expandale-icon"
                >
                  {expandedRows[row._id] ? <IndeterminateCheckBoxOutlinedIcon style={{ fill: '#3f4255' }} /> : <AddBoxOutlinedIcon style={{ fill: '#3f4255' }} />}
                </IconButton>
              </TableCell>
            )}
             <TableCell
                align="left"
              >
              <AccountWrapper>
                <Account onClick={() => history.push(`/event-participants/details/${row?.event?._id}/?groupId=${row?.groupId}`)}>{row?.groupId}</Account>
              </AccountWrapper>
             </TableCell>
            
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              <div className="participant__name">
                <div className="participant__name-text">
                  {row?.firstName}
                </div>
              </div>
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.lastName}
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.phone || '-'}
            </TableCell>
            {!isFreeEvent && (
              <TableCell className="payment__status" align="left">
                <Status type={row?.registrationStatus}>
                  {row?.registrationStatus || 'pending'}
                </Status>
              </TableCell>
            )}

            {!isFreeEvent && (
              <TableCell
                className="charged-value"
                align="left"
                onClick={() => {
                  setDrawerData(row);
                  setOpenDrawer(true);
                }}
              >
                {numberFormat({number: +row?.payment?.register?.totalPaid, decimal: 2, style: 'currency'})}
              </TableCell>
            )}
            {!isMultiEvent && (
              <TableCell align="left">
                <CheckBox
                  onChange={() => {
                    const current = row._id in attendedMap ? attendedMap[row._id] : !!row?.attended;
                    handleAttendeeChange(row, !current);
                  }}
                  checked={row._id in attendedMap ? attendedMap[row._id] : !!row?.attended}
                  text=""
                />
              </TableCell>
            )}
            <TableCell className="sticky-body-column" align="right">
              <div
                style={{
                  cursor: 'pointer',
                  paddingleft: '0px',
                }}
              >
                <Action
                  action="participant"
                  style={{ 
                      minHeight: '30px',
                      paddingBottom: "10px",
                   }}
                  onEditViewClick={() => {
                    setDrawerData(row);
                    setOpenDrawer(true);
                   }}
                  // onSendPaymentLinkClick={() => {
                  //   onSharePaymentLinkClick(row);
                  // }}

                  onParticipantDeleteClick={ row?.registrationStatus?.toLowerCase() !== "deleted" ? () => {
                    setCurrentRow(row);
                    setDeleteId(row._id);
                    setConfirmDialog(true);
                  } : undefined}
          
                  setClassMovedId={setClassMovedId}
                  setConfirmDialog={setConfirmDialog}
                />
              </div>
            </TableCell>
          </TableRow>
          {isMultiEvent && (
            <TableRow>
              <TableCell colSpan={9} style={{ padding: 0, border: 0 }}>
                <Collapse in={!!expandedRows[row._id]} timeout="auto" unmountOnExit>
                  <Box>
                    <Table size="small" aria-label="event-dates" style={{ tableLayout: 'fixed', width: '100%' }}>
                      <TableHead>
                        <TableRow style={{ background: '#f3f6f9' }}>
                          <TableCell style={{ border: 'none', width: '5%' }} />
                          <TableCell style={{ border: 'none', width: '5%' }} />
                          <TableCell style={{ border: 'none', width: '40%' }}>
                            <span style={{ fontFamily: fontConfig.EventsParticipantDetailsTableBodyTextFont.family, fontWeight: 600, fontSize: '11px', lineHeight: '32px', color: '#4d5565' }}>EVENT NAME</span>
                          </TableCell>
                          <TableCell style={{ border: 'none', width: '25%' }}>
                            <span style={{ fontFamily: fontConfig.EventsParticipantDetailsTableBodyTextFont.family, fontWeight: 600, fontSize: '11px', lineHeight: '32px', color: '#4d5565' }}>UPDATED AT</span>
                          </TableCell>
                          <TableCell style={{ border: 'none', width: '25%' }}>
                            <span style={{ fontFamily: fontConfig.EventsParticipantDetailsTableBodyTextFont.family, fontWeight: 600, fontSize: '11px', lineHeight: '32px', color: '#4d5565' }}>ATTENDED</span>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(row?.eventsDates || []).map((dateEntry, idx) => {
                          const dateKey = dateEntry.name;
                          const mapKey = `${row._id}__${dateKey}`;
                          const isAttended = mapKey in dateAttendanceMap
                            ? dateAttendanceMap[mapKey]
                            : !!(dateEntry.attended);
                          // the event's current date for this registration (dates can be moved after people register)
                          const registeredDate = getCurrentRegisteredDate(dateEntry, eventDates);
                          const localDateStr = registeredDate
                            ? new Date(registeredDate).toLocaleString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }).replace(',', '')
                            : '-';
                          const eventNameDisplay = [dateEntry.label, dateEntry.variant, localDateStr].filter(Boolean).join(' - ');
                          return (
                            <TableRow key={idx} style={{ background: 'rgb(249, 251, 252)' }}>
                              <TableCell style={{ border: 'none' }} />
                              <TableCell style={{ border: 'none' }} />
                              <TableCell style={{ border: 'none', fontFamily: fontConfig.EventsTableCellFont.family, fontWeight: 500, fontSize: '14px', color: '#4D5565' }}>
                                {eventNameDisplay}
                              </TableCell>
                              <TableCell style={{ border: 'none', fontFamily: fontConfig.EventsTableCellFont.family, fontWeight: 500, fontSize: '14px', color: '#4D5565' }}>
                                {row?.updatedAt ? formatDate({ date: row.updatedAt, formatType: 'defaultWithTime' }) : '-'}
                              </TableCell>
                              <TableCell style={{ border: 'none' }}>
                                <CheckBox
                                  text=""
                                  checked={isAttended}
                                  onChange={() => handleAttendeeChange(row, !isAttended, dateKey)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          )}
          </React.Fragment>
        ))
      )}
      <AlertDialog
        open={confirmDialog}
        onDecline={() => {
          setDeleteId(null);
          setPaymentLinkId(null);
          setSelectedStatus(null);
          setCurrentRow(null);
          setConfirmDialog(false);
        }}
        onAccept={() => {
          if (deleteId) {
            deleteEventParticipant(deleteId);
          }
          if (selectedStatus?.id) {
            changeStatus(selectedStatus);
          }
          if (paymentLinkId) {
            sendPaymentLink(paymentLinkId);
          }
          if (moveParticipantId && classMovedId) {
            moveParticipantToAnotherClass();
          }
        }}
        title={"Are you sure?"}
        description={selectedStatus?.id ? getStatusMessage(selectedStatus?.value, currentRow) : deleteId ? getDeleteMessage(currentRow) : ''}
        disabled={confirmLoading}
      />
      <AlertDialog
        open={attendeeDialog}
        onDecline={() => {
          setAttendeeDialog(false);
          setAttendeeRow(null);
          setAttendeeValue(null);
        }}
        onAccept={confirmAttendee}
        title={"Are you sure?"}
        description="Do you want to mark participant as unattended?"
        disabled={attendeeLoading}
      />
    </>
  );
};

export default ParticipantDetailsTableBody;
